export const PrivacyList = [
  {
    id: 1,
    title: "آزتو چه اطلاعاتی را ذخیره می‌کند؟",
    description:
      "اطلاعاتی که پس از ثبت نام کاربرها، آزتو ذخیره می‌کند شامل، نام، نام‌خانوادگی، کد ملی، شماره همراه و ایمیل است. از این اطلاعات هیچ گونه استفاده تجاری و غیر تجاری نمی‌شود و این اطلاعات به هیچ وجه در اختیار افراد حقوقی و حقیقی دیگر قرار نمی‌گیرد.  تمامی اطلاعات شخصی شما که در آزتو ذخیره می‌شود جز اسرار محرمانه است و فاش نخواهد شد. هدف از ذخیره اطلاعات کاربر‌ها ارائه سرویس بهتر و بهبود خدمات‌دهی است.",
  },
  {
    id: 2,
    title: "نظرها و دیدگاه‌ها کجا می‌روند؟ ",
    description:
      "آزتو زمانی که کاربر دیدگاه خود را ارسال می‌کند، اطلاعاتی که در فرم ارسال دیدگاه نمایش داده می‌شود را ذخیره می‌کند. پس از ثبت دیدگاه و نظر، تیم بازبینی محتوا آن را بررسی و سپس اجازه تایید و ثبت آن را می‌دهد.  همچنین این دیدگاه‌ها با ذکر نام و نام‌خانوادگی منتشر می‌شوند. ",
  },
  {
    id: 3,
    title: "کوکی‌ها چه کاری انجام می‌دهند؟",
    description:
      "برای سرعت بخشیدن و صرفه‌جویی در زمان، از کوکی‌ها در سایت استفاده شده است. با کوکی‌ها، استفاده از وب سایت را شخصی‌سازی خواهید کرد و در زمان مراجعه مجدد و برای بازدیدهای بعدی نیازی به وارد کردن اطلاعات تکراری ندارید. با این حال امکان غیر فعال کردن کوکی‌ها توسط کاربر وجود دارد. ",
  },
  {
    id: 4,
    title: "آزتو در قبال مطالب منتشر شده از سایت‌های دیگر چه مسئولیتی دارد؟",
    description:
      "در مواقعی که شما بازدیدکننده مطالبی که در آزتو از وب سایت‌های دیگر جاگذاری شده‌اند، مانند ویدیوها، مقالات، تصاویر و...، هستید، در واقع بازدیدکننده آن وب‌سایت هستید و ممکن است اطلاعاتی از شما در آن ذخیره شود. ",
  },
  {
    id: 5,
    title: "همکاران آزتو و تعهد آن‌ها چیست؟",
    description:
      "همکاران و پرسنل آزتو که به صورت تمام‌وقت یا پاره‌وقت در آن فعالیت می‌کنند و به اطلاعات کاربرها دسترسی دارند با امضای تعهدنامه عدم افشای اطلاعات محرمانه، متعهد و ملزم به رعایت قوانین سازمانی آزتو هستند.",
  },
  {
    id: 6,
    title: "ارتباط آزتو با کاربرها از چه طریقی است؟",
    description:
      "ارتباط ما با کاربرها از طریق سایت با آدرس azeto.ir، شماره تماس‌ها و ایمیل‌های ثبت شده در سایت آزتو می‌باشد. آزتو برای ارتباط با کاربرها فقط از طریق روش‌های نام برده شده، استفاده می‌کند. ",
  },
];
